export default __webpack_public_path__ + "2da6b97723d5c09d0d36f0980023e0c8.gif";